//
// Visuals
//

var THREE = window.THREE = require('three')
require('./THREEColladaLoader.js')
require('./THREECombinedCamera.js')

var visuals = {
  appRoot: '',
  shapesFolder: 'media/shapes/',
  shapesNames: [ 'cube', 'cylinder', 'pyramid', 'sphere', 'torus' ],
  shapesFiles: {
    twirl: 'twirl.dae',
    spiral: 'spiral1.dae',
    diamond: 'diamond4.dae'
  },
  shapesGeometry: {
    cube: new THREE.BoxGeometry(8, 8, 8),
    cylinder: new THREE.CylinderGeometry(5, 5, 20, 32),
    pyramid: new THREE.TetrahedronGeometry(5),
    sphere: new THREE.SphereGeometry(5, 32, 32),
    torus: new THREE.TorusGeometry(5, 3, 16, 32)
  },
  shapesInfo: {
    cube: {
      rotateAxis: 'xyz'
    },
    cylinder: {
      rotateAxis: 'xz'
    },
    pyramid: {
      rotateAxis: 'xyz'
    },
    sphere: {
      rotateAxis: ''
    },
    torus: {
      rotateAxis: 'xy'
    },
    twirl: {
      rotateAxis: 'xyz'
    },
    spiral: {
      rotateAxis: 'y'
    },
    diamond: {
      rotateAxis: 'xyz'
    }
  },
  shapes: [],
  loadCount: 0,
  loadIndex: 0,
  loadProgress: 0,
  materials: [
    // Blue
    new THREE.MeshLambertMaterial({
      color: 0x7CDAFF
    }),
    // Red
    new THREE.MeshLambertMaterial({
      color: 0xFF5E5E
    }),
    // Yellow
    new THREE.MeshLambertMaterial({
      color: 0xFFDA64
    }),
    // Black
    new THREE.MeshLambertMaterial({
      color: 0x2A2A2A
    }),
    // White
    new THREE.MeshLambertMaterial({
      color: 0xEEEEEE
    }),
    // Grey
    new THREE.MeshLambertMaterial({
      color: 0x666666
    })
  ],
  group: {},
  objects: {},
  debug: {},
  scene: {},
  viewport: {},
  camera: {},
  renderer: {},
  utils: {},
  values: {
    // Window
    winHalfX: window.innerWidth * 0.5,
    winHalfY: window.innerHeight * 0.5,
    winAspect: window.innerWidth / window.innerHeight,
    // Mouse
    mouseX: 0,
    mouseY: 0,
    centerXRatio: 0,
    centerYRatio: 0,
    // Animation
    growShapes: 0,
    spinAmount: 0.001,
    spinAmountY: 0,
    newSpinAmount: 0.001,
    newSpinAmountY: 0,
    groupRotationAmount: 0,
    // Blur
    blurAmount: 0.1
  },
  isBlurred: false,
  isHighQuality: true,
  doAnimate: true,
  currentViewMode: 0
}

// Give 'em names for debugging purposes
for (var i in visuals.shapesGeometry) {
  if (visuals.shapesGeometry.hasOwnProperty(i)) {
    visuals.shapesGeometry[i].name = i
  }
}

// Rendered into bits
// visuals.renderer = new THREE.WebGLRenderer()
visuals.viewport = document.getElementById('viewport')

// Horrible scene
visuals.scene = new THREE.Scene()
visuals.group = new THREE.Object3D()
visuals.gridCells = []
visuals.signaturePoints = []
visuals.signaturePath = undefined
visuals.signatureGeom = undefined
visuals.signature = undefined
visuals.signatureCursor = undefined

// I like to watch...
visuals.camera = new THREE.CombinedCamera(visuals.values.winHalfX, visuals.values.winHalfX, 20, 1, 1000, - 500, 1000)
visuals.camera.position.set(0, 0, 600)
visuals.camera.lookAt(visuals.scene.position)

// A little mood lighting...
visuals.ambientLight = new THREE.AmbientLight(0x666666)
visuals.scene.add(visuals.ambientLight)

visuals.mainLight = new THREE.PointLight(0xffffcc, 0.8, 0)
visuals.mainLight.position.set(-200, -200, 200)
visuals.scene.add(visuals.mainLight)

visuals.keyLight = new THREE.PointLight(0xff88ee, 0.6, 0)
visuals.keyLight.position.set(200, 200, -100)
visuals.scene.add(visuals.keyLight)

// Loaded with stuff
visuals.manager = window.THREELoader = new THREE.LoadingManager()
visuals.daeLoader = new THREE.ColladaLoader(visuals.manager)

// Load model
visuals.loadModel = function (modelFile, cb) {
  // @debug
  // console.log('loadModel', modelFile)
  visuals.loadIndex++
  visuals.daeLoader.load(visuals.appRoot + visuals.shapesFolder + modelFile, function (collada) {
    var dae = collada.scene
    var geom = undefined

    dae.traverse(function (child) {
      if (child instanceof THREE.Mesh) {
        geom = child.geometry
      }
    })

    if (typeof cb === 'function') cb(modelFile, geom)

  }, visuals.onLoaderProgress, visuals.onLoaderError)
}

visuals.loadShape = function (shapeName, cb) {
  visuals.loadModel(visuals.shapesFiles[shapeName], function (shapeFile, geom) {
    visuals.addShapeGeometry(shapeName, geom)

    if (typeof cb === 'function') cb.call(visuals, shapeName, geom)
  })
}

visuals.addShapeGeometry = function (shapeName, geom) {
  visuals.shapesGeometry[shapeName] = geom
  geom.name = shapeName
  visuals.shapesNames.push(shapeName)
}

// Generate shape
visuals.generateShape = function (shapeName, material) {
  var shape = undefined
  var shapeGeometry = undefined

  // @debug
  // console.log('visuals.generateShape', shapeName)

  if (shapeName in visuals.shapesGeometry) {
    shapeGeometry = visuals.shapesGeometry[shapeName]
  } else {
    shapeName = visuals.shapesNames[visuals.utils.rand(visuals.shapesNames.length)]
    shapeGeometry = visuals.shapesGeometry[shapeName]
  }

  if (!material) {
    material = visuals.materials[visuals.utils.rand(3)]
  }

  // New shape
  shape = new THREE.Mesh(shapeGeometry, material)
  shape.castShadow = true
  shape.receiveShadow = true
  shape.name = shapeName + visuals.shapes.length
  // scene.add(shape)
  visuals.shapes.push(shape)

  return shape
}

visuals.onWindowResize = function () {
  visuals.values.winHalfX = window.innerWidth * 0.5
  visuals.values.winHalfY = window.innerHeight * 0.5
  visuals.values.winAspect = window.innerWidth / window.innerHeight

  // visuals.camera.aspect = visuals.values.winAspect
  var setWidth = window.innerWidth
  var setHeight = window.innerHeight

  // Change dimensions if marked as blurred
  if (visuals.isBlurred) {
    setWidth = setWidth * visuals.values.blurAmount
    setHeight = setHeight * visuals.values.blurAmount
  }

  // Update camera size
  visuals.camera.setSize(setWidth, setHeight)
  visuals.camera.updateProjectionMatrix()

  // Update renderer size
  visuals.renderer.setSize(setWidth, setHeight)

  // Only render if not currently animating
  if (!visuals.doAnimate) {
    visuals.render()
  }
}

visuals.onDocumentMouseMove = function (event) {
  visuals.values.mouseX = event.clientX
  visuals.values.mouseY = event.clientY

  visuals.values.centerXRatio = (visuals.values.winHalfX - visuals.values.mouseX) / visuals.values.winHalfX
  visuals.values.centerYRatio = (visuals.values.winHalfY - visuals.values.mouseY) / visuals.values.winHalfY

  visuals.values.newSpinAmount = -visuals.values.centerXRatio * 0.02
  visuals.values.newSpinAmountY = -visuals.values.centerYRatio * 0.01

  // @debug
  // console.log("mouse=%f, %f, ratio=%f, %f", event.clientX, event.clientY, visuals.values.centerXRatio, visuals.values.centerYRatio)
}

visuals.utils.rand = function (min, max) {
  if (max) {
    return min + Math.floor(Math.random() * (max - min))
  } else {
    return Math.floor(Math.random() * min)
  }
}

visuals.utils.deg2r = function (degrees) {
  return degrees * (Math.PI / 180)
}

visuals.utils.r2deg = function (r) {
  return r / (Math.PI / 180)
}

visuals.utils.roundToMultiple = function (input, multiple) {
  input = Math.ceil(input / multiple) * multiple
  return input
}

visuals.ensureSignatureInBottomRight = function () {
  // Position signature to always be bottom right of view
  if (visuals.currentViewMode === 0) {
    visuals.objects.signature.position.x = visuals.values.winHalfX * 0.2
    visuals.objects.signature.position.y = -visuals.values.winHalfY * 0.2
  } else {
    visuals.objects.signature.position.set((visuals.values.winHalfX * 0.2), -(visuals.values.winHalfY * 0.2), 0)
  }
}

visuals.getObjectDimensions = function (object) {
  var output = {}

  if (object instanceof THREE.Object3D) {
    var bbox = visuals.objects.bbox = new THREE.Box3().setFromObject(object)

    if (bbox.geometry.boundingBox) {
      for (var i in bbox.geometry.boundingBox.min) {
        output[i] = Math.abs(bbox.geometry.boundingBox.max[i] - bbox.geometry.boundingBox.min[i])
      }
    }
  }

  return output
}

visuals.generateComposition = function (width, height, depth, cellX, cellY, cellZ, amount, debug) {
  if (visuals.group) visuals.scene.remove(visuals.group)

  // Make new 3D object holders
  visuals.group = new THREE.Object3D()
  visuals.debug = new THREE.Object3D()

  // Add the debug group to the regular group
  visuals.debug.visible = debug || false
  visuals.group.add(visuals.debug)

  // Reset values
  visuals.values.spinAmount = 0.001
  visuals.values.newSpinAmount = 0.001

  // Determine cell positions within grid
  // -- Dimensions of cell within grid
  cellX = THREE.Math.clamp(cellX || 50, 40, 100)
  cellY = THREE.Math.clamp(cellY || 50, 40, 100)
  cellZ = THREE.Math.clamp(cellZ || 50, 40, 100)

  // -- Dimensions of grid
  width = visuals.utils.roundToMultiple(THREE.Math.clamp(width || 100, 40, 400), cellX) - 50
  height = visuals.utils.roundToMultiple(THREE.Math.clamp(height || visuals.values.winHalfY * 0.25, 40, 400), cellY)
  depth = visuals.utils.roundToMultiple(THREE.Math.clamp(depth || visuals.values.winHalfX * 0.25, 40, 400), cellZ)

  // -- Clamp depth/height dimensions so people don't get too bogged
  if (depth > cellZ * 5) depth = cellZ * 5
  if (height > cellY * 5) height = cellY * 5

  // -- Amount to deviate within cell
  amount = THREE.Math.clamp(amount || 0.66, 0.1, 1)

  // @debug
  // console.log('visuals.generateComposition', width, height, depth, cellX, cellY, cellZ, amount)

  // -- Bounding box (min/max values)
  var gridBox = visuals.objects.gridBox = new THREE.Mesh(new THREE.BoxGeometry(width, height, depth), new THREE.MeshBasicMaterial({
    color: 0x000000,
    wireframe: true
  }))
  var gbGeom = gridBox.geometry
  gbGeom.computeBoundingBox()
  // visuals.group.add(visuals.objects.gridBox)

  // Add extra info for other methods to reference
  var gb = gridBox.lvl99 = {
    gridCells: [],
    width: width,
    height: height,
    depth: depth,
    cellX: cellX,
    cellY: cellY,
    cellZ: cellZ,
    maxX: Math.floor(width / cellX),
    maxY: Math.floor(height / cellY),
    maxZ: Math.floor(depth / cellZ),
    amount: amount
  }

  // @debug
  // console.log('visuals.objects.gridBox', gb)

  var countX = 0
  var countY = 0
  var countZ = 0

  // Generate the cells
  for (var i = 0; i < (gb.maxX * gb.maxY * gb.maxZ); i++) {
    var gridCellIndex = visuals.getGridCellIndex(i, gridBox)

    var cellPos = new THREE.Vector3(
      gbGeom.boundingBox.min.x + (gridCellIndex.x * gb.cellX) + visuals.utils.rand(gb.cellX * gb.amount) + (gb.cellX * 0.5),
      gbGeom.boundingBox.min.y + (gridCellIndex.y * gb.cellY) + visuals.utils.rand(gb.cellY * gb.amount) + (gb.cellY * 0.5),
      gbGeom.boundingBox.min.z + (gridCellIndex.z * gb.cellZ) + visuals.utils.rand(gb.cellZ * gb.amount) + (gb.cellZ * 0.5)
      // gbGeom.boundingBox.min.x + (gridCellIndex.x * gb.cellX) + (gb.cellX * 0.5),
      // gbGeom.boundingBox.min.y + (gridCellIndex.y * gb.cellY) + (gb.cellY * 0.5),
      // gbGeom.boundingBox.min.z + (gridCellIndex.z * gb.cellZ) + (gb.cellZ * 0.5)
  )

    gb.gridCells[i] = {
      index: i,
      cellIndex: gridCellIndex,
      pos: cellPos
    }

    // @debug
    var cellFrame = new THREE.Mesh(
      new THREE.BoxGeometry(gb.cellX, gb.cellY, gb.cellZ),
      new THREE.MeshBasicMaterial({
        color: 0x999999,
        wireframe: true
      })
    )
    cellFrame.position.copy(cellPos)
    visuals.debug.add(cellFrame)
  }

  // Draw lines
  var linePathPoints = visuals.generateLinePoints(gridBox)

  // -- Render line
  var linePath = new THREE.CatmullRomCurve3(linePathPoints)
  var lineGeom = new THREE.TubeGeometry(
    linePath,
    512,
    0.2,
    16
  )
  lineGeom.center()
  visuals.objects.line = new THREE.Mesh(lineGeom, visuals.materials[3])
  visuals.group.add(visuals.objects.line)

  // Add shapes
  visuals.shapes = []
  var shapeCells = gb.gridCells.slice(0)
  var shapesNames = visuals.shapesNames.slice(0)
  var perLayer = gb.maxX * gb.maxY
  var maxPerLayer = Math.floor(perLayer * amount) || 1

  // @debug
  // console.log('gridbox', 'maxX='+gb.maxX, 'maxY='+gb.maxY, 'maxZ='+gb.maxZ, 'cellsLength='+shapeCells.length)
  // console.log('shapes', 'perLayer='+perLayer, 'maxPerLayer='+maxPerLayer, 'totalShapesLibrary='+visuals.shapesNames.length)

  for (var i = 0; i < gb.maxZ; i++) {
    for (var j = 0; j < maxPerLayer; j++) {
      var shapeName, shapeInfo

      // -- Shape position
      var randCellIndex = (i * perLayer) + visuals.utils.rand(perLayer)
      var shapeCell = shapeCells[randCellIndex]
      var countTries = 0
      while (shapeCell.hasOwnProperty('hasShape') && shapeCell.hasShape && countTries < 3) {
        countTries++
        randCellIndex = (i * perLayer) + visuals.utils.rand(perLayer)
        shapeCell = shapeCells[randCellIndex]

        // @debug
        // console.log('looking for cell with no shape', countTries, !!shapeCell.hasShape)
      }

      // Three strikes and you're out
      if (countTries >= 3) {
        // @debug
        // console.log('No shape for you!')
        continue
      }

      // Mark cell has shape so multiple shapes aren't generated into the same cell
      shapeCell.hasShape = true

      // Exhausted shapes list? Clone a new one
      if (shapesNames.length === 0)
        shapesNames = visuals.shapesNames.slice(0)

      // Pick a random shape
      shapeName = shapesNames.splice(visuals.utils.rand(shapesNames.length), 1)[0]
      shapeInfo = visuals.shapesInfo[shapeName]

      // -- Generate shape
      var shape = visuals.generateShape(shapeName, visuals.materials[(i + j) % 3])
      shape.lvl99 = {}

      shape.lvl99.position = shapeCell.pos
      shape.position.set(0, 0, 0)

      // -- Shape scale
      shape.lvl99.scale = visuals.utils.rand(2, 3)
      shape.scale.set(0, 0, 0)

      // -- Shape rotation
      shape.rotation.set(Math.random(), Math.random(), Math.random())

      // -- Rotate the object around certain axes
      if (shapeInfo.rotateAxis) {

        var axes = shapeInfo.rotateAxis.split('')
        var axesCount = 1 + visuals.utils.rand(axes.length - 1)

        shape.lvl99.rotate = {}

        for (var k = 0; k < axesCount; k++) {
          rotateOnAxis = axes.splice(visuals.utils.rand(axes.length))[0]
          shape.lvl99.rotate[rotateOnAxis] = visuals.utils.deg2r((Math.random() / 10) - ((Math.random() * 2) / 10))
        }

        shape.needsUpdate = true
      }

      // Add shape to the render group
      visuals.group.add(shape)
    }
  }

  // Render group
  visuals.group.scale.set(0, 0, 0)
  visuals.group.rotation.y = visuals.utils.deg2r(270)
  visuals.values.growShapes = 1
  visuals.values.groupRotationAmount = 0.75
  visuals.scene.add(visuals.group)
}

visuals.generateLinePoints = function (gridBox) {
  var linePathCells = gridBox.lvl99.gridCells.slice(0)
  var linePathPoints = []

  // First point
  linePathPoints.push(new THREE.Vector3(
    visuals.utils.rand(gridBox.geometry.boundingBox.min.x - gridBox.geometry.boundingBox.max.x),
    visuals.utils.rand(gridBox.geometry.boundingBox.min.y - gridBox.geometry.boundingBox.max.y),
    visuals.utils.rand(gridBox.geometry.boundingBox.min.z - gridBox.geometry.boundingBox.max.z)
 ))

  // Middle points
  // -- Restrict number of cells referenced per layer
  var perLayer = gridBox.lvl99.maxX * gridBox.lvl99.maxY
  var maxPerLayer = THREE.Math.clamp(Math.ceil(perLayer * 0.75), 1, 5)
  var countPerLayer = []
  for (var i = 0; i < gridBox.lvl99.maxZ; i++) {
    countPerLayer[i] = 0
  }

  for (var i = 0; i < linePathCells.length; i++) {
    var lineCell = linePathCells.splice(visuals.utils.rand(linePathCells.length), 1)[0]

    if (countPerLayer[lineCell.cellIndex.z] < maxPerLayer) {

      // -- Connect object to line
      if (visuals.utils.rand(3) == 3) {
        linePathPoints.push(lineCell.pos)

      // -- Don't connect object
      } else {
        linePathPoints.push(new THREE.Vector3(
          lineCell.pos.x + visuals.utils.rand(-gridBox.lvl99.cellX, gridBox.lvl99.cellX),
          lineCell.pos.y + visuals.utils.rand(-gridBox.lvl99.cellY, gridBox.lvl99.cellY),
          lineCell.pos.z + visuals.utils.rand(-gridBox.lvl99.cellZ, gridBox.lvl99.cellZ)
       ))
      }

      countPerLayer[lineCell.cellIndex.z] += 1
    }
  }

  // Last point
  linePathPoints.push(new THREE.Vector3(
    visuals.utils.rand(gridBox.geometry.boundingBox.min.x - gridBox.geometry.boundingBox.max.x),
    visuals.utils.rand(gridBox.geometry.boundingBox.min.y - gridBox.geometry.boundingBox.max.y),
    visuals.utils.rand(gridBox.geometry.boundingBox.min.z - gridBox.geometry.boundingBox.max.z)
 ))

  return linePathPoints
}

visuals.growShapes = function () {
  for (var i in visuals.shapes) {
    var shape = visuals.shapes[i]

    if (shape.position.x != shape.lvl99.position.x) shape.position.x += (shape.lvl99.position.x - shape.position.x) * 0.1
    if (shape.position.y != shape.lvl99.position.y) shape.position.y += (shape.lvl99.position.y - shape.position.y) * 0.1
    if (shape.position.z != shape.lvl99.position.z) shape.position.z += (shape.lvl99.position.z - shape.position.z) * 0.1

    if (shape.scale.x < shape.lvl99.scale) shape.scale.x += (shape.lvl99.scale - shape.scale.x) * 0.1
    if (shape.scale.y < shape.lvl99.scale) shape.scale.y += (shape.lvl99.scale - shape.scale.y) * 0.1
    if (shape.scale.z < shape.lvl99.scale) shape.scale.z += (shape.lvl99.scale - shape.scale.z) * 0.1
  }

  if (visuals.group.scale.x < 1) visuals.group.scale.x += (1 - visuals.group.scale.x) * 0.1
  if (visuals.group.scale.y < 1) visuals.group.scale.y += (1 - visuals.group.scale.y) * 0.1
  if (visuals.group.scale.z < 1) visuals.group.scale.z += (1 - visuals.group.scale.z) * 0.1

  visuals.values.groupRotationAmount += (0 - visuals.values.groupRotationAmount) * 0.1

  if (visuals.group.scale.x === visuals.group.scale.y === visuals.group.scale.z === 1 && visuals.values.groupRotationAmount > 0) {
    visuals.values.growShapes = 0
    visuals.values.groupRotationAmount = 0
  }
}

visuals.getGridCellIndex = function (i, gridBox) {
  var output = {
    x: 0,
    y: 0,
    z: 0
  }

  output.x = i % gridBox.lvl99.maxX
  output.y = Math.floor(i / gridBox.lvl99.maxX) % gridBox.lvl99.maxY
  output.z = Math.floor(i / (gridBox.lvl99.maxX * gridBox.lvl99.maxY))

  return output
}

visuals.changeCamera = function (selectCamera) {
  switch (selectCamera) {
    case 'perspective':
    case 'd':
    case 'p':
    case 68:
    case 80:
    default:
      // Perspective
      visuals.camera.toPerspective()
      visuals.camera.setFov(20)
      visuals.camera.position.x = 0
      visuals.camera.position.y = 0
      visuals.camera.position.z = 600
      visuals.camera.lookAt(visuals.scene.position)
      visuals.currentViewMode = 0
      break

    case 'x':
    case 88:
      visuals.camera.toOrthographic()
      visuals.camera.toLeftView()
      visuals.camera.setFov(40)
      visuals.camera.position.x = 200
      visuals.camera.position.y = 0
      visuals.camera.position.z = 0
      visuals.camera.lookAt(visuals.scene.position)
      visuals.currentViewMode = 1
      break

    case 'y':
    case 89:
      visuals.camera.toOrthographic()
      visuals.camera.toBottomView()
      visuals.camera.setFov(40)
      visuals.camera.position.x = 0
      visuals.camera.position.y = 200
      visuals.camera.position.z = 0
      visuals.camera.lookAt(visuals.scene.position)
      visuals.currentViewMode = 2
      break

    case 'z':
    case 90:
      visuals.camera.toOrthographic()
      visuals.camera.toFrontView()
      visuals.camera.setFov(40)
      visuals.camera.position.x = 0
      visuals.camera.position.y = 0
      visuals.camera.position.z = -200
      visuals.camera.lookAt(visuals.scene.position)
      visuals.currentViewMode = 3
      break
  }

  visuals.onWindowResize()
}

visuals.init = function () {
  // Generate a composition
  visuals.generateComposition()

  // Signature
  visuals.signaturePoints = [
    new THREE.Vector3(163, 144, 40),
    new THREE.Vector3(-25, -43, 35),
    new THREE.Vector3(42, 53, 30),
    new THREE.Vector3(34, 99, 25),
    new THREE.Vector3(-15, 109, 20),
    new THREE.Vector3(-82, 82, 15),
    new THREE.Vector3(-125, 38, 10),
    new THREE.Vector3(-141, -14, 5),
    new THREE.Vector3(-104, -33, 0),
    new THREE.Vector3(-43, -14, -5),
    new THREE.Vector3(15, 4, -10),
    new THREE.Vector3(79, 4, -15),
    new THREE.Vector3(90, -23, -20),
    new THREE.Vector3(26, -28, -25),
    new THREE.Vector3(-7, -14, -30),
    new THREE.Vector3(14, -4, -35),
    new THREE.Vector3(-106, -160, -40)
  ]
  visuals.signaturePath = new THREE.CatmullRomCurve3(visuals.signaturePoints)
  visuals.signatureGeom = new THREE.TubeGeometry(
    visuals.signaturePath,
    100,
    2,
    4
  )
  visuals.objects.signature = new THREE.Object3D()
  visuals.objects.sig = new THREE.Mesh(visuals.signatureGeom, new THREE.MeshBasicMaterial({
    color: 0x7CDAFF
  }))
  visuals.objects.signature.add(visuals.objects.sig)

  // Position signature
  visuals.ensureSignatureInBottomRight()
  visuals.objects.signature.scale.set(0.1, 0.1, 0.1)
  visuals.objects.signature.rotation.set(0, 0, 0)
  visuals.scene.add(visuals.objects.signature)

  // Renderer
  if (visuals.isHighQuality) {
    visuals.highQuality()
  } else {
    visuals.lowQuality()
  }

  // Events
  window.addEventListener('resize', visuals.onWindowResize, false)
  document.addEventListener('mousemove', visuals.onDocumentMouseMove, false)

  // Refresh window dimensions
  visuals.onWindowResize()

  // Render
  visuals.animate()
}

visuals.animate = function () {
  requestAnimationFrame(visuals.animate)

  // Specific animation stuff
  if (visuals.doAnimate) {
    if (visuals.values.growShapes) visuals.growShapes()

    for (var i = 0; i < visuals.shapes.length; i++) {
      var shape = visuals.shapes[i]
      if (shape.lvl99 && shape.lvl99.rotate) {
        for (var j in shape.lvl99.rotate) {
          if (shape.lvl99.rotate.hasOwnProperty(j)) {
            shape.rotation[j] += shape.lvl99.rotate[j]
          }
        }
      }
    }

    // Fraction too much friction on the spin amounts
    visuals.values.spinAmount += (visuals.values.newSpinAmount - visuals.values.spinAmount) * 0.5
    visuals.values.spinAmountY += (visuals.values.newSpinAmountY - visuals.values.spinAmountY) * 0.5

    // Spin the group
    visuals.group.rotation.y += visuals.values.spinAmount + visuals.values.groupRotationAmount
    visuals.group.rotation.x += ((visuals.values.spinAmountY * 10) - visuals.group.rotation.x) * 0.5

    // Spin the signature
    // visuals.objects.signature.lookAt(visuals.camera)
    visuals.objects.signature.rotation.x = -visuals.utils.deg2r((visuals.values.centerYRatio * 10) + 30)
    visuals.objects.signature.rotation.y = -visuals.utils.deg2r((visuals.values.centerXRatio * 10))

    visuals.ensureSignatureInBottomRight()
  }

  // Render
  visuals.render()
}

// Render the scene
visuals.render = function () {
  visuals.renderer.render(visuals.scene, visuals.camera)
}

// Low quality
visuals.lowQuality = function () {
  visuals.renderer = new THREE.WebGLRenderer()
  visuals.renderer.shadowMap.enabled = false

  // Put renderer in the scene
  visuals.renderer.setClearColor(0xffffff, 1)
  visuals.viewport.innerHTML = ''
  visuals.viewport.appendChild(visuals.renderer.domElement)

  visuals.onWindowResize()
}

// High quality
visuals.highQuality = function () {
  visuals.renderer = new THREE.WebGLRenderer({
    antialias: true,
    preserveDrawingBuffer: true
  })
  visuals.renderer.shadowMap.enabled = true
  visuals.renderer.shadowMap.type = THREE.PCFSoftShadowMap

  // Put renderer in the scene
  visuals.renderer.setClearColor(0xffffff, 1)
  visuals.viewport.innerHTML = ''
  visuals.viewport.appendChild(visuals.renderer.domElement)

  visuals.onWindowResize()
}

// Blur
visuals.blur = function () {
  visuals.isBlurred = true
  visuals.onWindowResize()
}

// Focus
visuals.focus = function () {
  visuals.isBlurred = false
  visuals.onWindowResize()
}

// Load the shapes
visuals.loadCount = 3
visuals.loadShape('twirl', function () {
  visuals.loadShape('spiral', function () {
    visuals.loadShape('diamond', function () {
      visuals.init()
    })
  })
})

module.exports = visuals
